<mat-toolbar color="primary">
    <span>Les attestations</span>
    <span class="toolbar-spacer"></span>
</mat-toolbar>
<app-contact-services-table [location]="'panel'"></app-contact-services-table>